import {Exclude, Expose, Type} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';
import {MediaObjectApiModel} from './media-object.api-model';

@Exclude()
export class PlaceCheckInVisitorApiModel {
  @Expose() public id: number;
  @Expose() public username: string;
  @Expose() public slug: string;
  @Expose() @Type(() => MediaObjectApiModel) public avatar: MediaObjectApiModel;
}

@Exclude()
export class PlaceCheckInApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public locationVerified: boolean;
  @Expose() public createdAt: Date;
  @Expose() @Type(() => PlaceCheckInVisitorApiModel) public user: PlaceCheckInVisitorApiModel;
}
